import { useEffect, useMemo, useState } from "react";

import './../Administrators.css';

import Axios from 'axios';

import Comp_PageName from "../../../components/PageName";
import { Btn, Input_Password, Input_Text, File } from "../../../components/Input";

import env from "../../../services/Env";
import { OpenPage } from "../../../services/OpenPage";
import { CallbackError, CallbackSuccess, CheckPassword } from "../../../services/Function";

import { GetDataPage, RegisterDataPage, SetListDataSingleItem, UnRegisterDataPage } from "../../../interface/Data";
import { SetStatusGlobal } from "../../../interface/Global";

interface ResponseData {
    id: number;
    name: string;
    email: string;
    file: string;
    status_data: boolean;
    update_data: boolean;
}

interface DataAdministrator {
    id : string;
    status : { value: number; label: string };
    name : string;
    email : string;
    file : string;
}

export default function Page_Administrators_Details() {

    const [ listData, setListData ] = useState<{ [key: string]: DataAdministrator }>(GetDataPage("administrators") || {});
    
    const [ pageId, setPageId ] = useState<number>(localStorage.getItem('page_id') ? parseInt(localStorage.getItem('page_id') as string) : 0);
    const [ closing, setClosing ] = useState<boolean>(false);
    
    const [ file, setFile ] = useState<File | string | null>(null);
    const [ name, setName ] = useState<string>('');
    const [ email, setEmail ] = useState<string>('');
    const [ password, setPassword ] = useState<string>('');
    const [ password2, setPassword2 ] = useState<string>('');

    const passwordCheck = useMemo(() => CheckPassword(password, password2), [password, password2]);

    // Clicar no fundo escurecido (fora do painel) fecha igual ao botao Cancel.
    function handleBackdrop(event: React.MouseEvent<HTMLFormElement>){
        if(event.target === event.currentTarget){
            handleClose();
        }
    }

    function handleClose() {
        setClosing(true);
        setTimeout(() => {
            OpenPage('administrators');
        }, 300);
    }

    async function SaveData(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        const passwordFilled = password !== '' || password2 !== '';
        const shouldValidatePassword = pageId === 0 || passwordFilled;

        if (shouldValidatePassword && !Object.values(passwordCheck).every(Boolean)){
                CallbackError("Password Error", "Please ensure the password meets all the requirements and both fields match.");
            return;
        }else {
            try {
                const formData = new FormData();
                formData.append('type_page', 'administrators');
                formData.append('type_data', 'edit_or_register');
                formData.append('id', String(pageId));
                formData.append('name', name);
                formData.append('email', email);
                formData.append('password', password);
                formData.append('file', file !== null ? file : '');
                formData.append('token', localStorage.getItem('token') || '');

                const response = await Axios.post<ResponseData>(env.apiUrl, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
                
                if(response.data.status_data){   
                    const newId = response.data.id;

                    setPageId(newId);
                    setFile(response.data.file);
                    setName(response.data.name);
                    setEmail(response.data.email);
                    localStorage.setItem('page_id', newId.toString());

                    SetListDataSingleItem('administrators', newId, { id: newId, name: response.data.name, email: response.data.email, file: response.data.file, status: { value: 1, label: 'Active' } });

                    if(response.data.update_data){
                        localStorage.setItem('user_name', response.data.name);
                        localStorage.setItem('user_file', response.data.file);
                        SetStatusGlobal('user_name', response.data.name);
                        SetStatusGlobal('user_file', response.data.file);
                    }
                    
                    CallbackSuccess("Saved information", "The administrator details have been successfully saved.");

                    // Gravou: fecha o painel e volta para a listagem. O PopUp de sucesso
                    // e global, entao continua na tela depois do Details sair.
                    handleClose();

                }else {
                    CallbackError("Error saving information", "There was an issue saving the administrator details. Please try again.");
                }
                
            }catch (error){
                CallbackError("Error saving information", "There was an issue saving the administrator details. Please try again.");
            }
        }
    }

    useEffect(() => {
        function handleData(data: any) {
            setListData(data || {});
        }
        RegisterDataPage('administrators', handleData);
        return () => UnRegisterDataPage('administrators', handleData);
    }, []);

    useEffect(() => {
        if (pageId !== 0 && Object.keys(listData).length > 0) {
            const showInf = listData[pageId];
            if (showInf) {
                setFile(showInf.file || '');
                setName(showInf.name || '');
                setEmail(showInf.email || '');
            }
        }
    }, [listData, pageId]);

    useEffect(()=>{
        setPageId(localStorage.getItem('page_id') ? parseInt(localStorage.getItem('page_id') as string) : 0);
    }, [localStorage.getItem('page_id')]);

    return(
        <form className="page_details Page_Administrators_Details" onSubmit={ SaveData } onClick={ handleBackdrop }>
            <div className={ `content_details ${ closing ? 'content_details_close' : '' }` }>
                
                <Comp_PageName 
                    title={ pageId === 0 ? "Add Administrator" : "Edit Administrator" }
                    subtitle={ pageId === 0 ? "Fill in the details to add a new administrator" : "Update the details of the administrator" }
                />

                <div className="div_btn">
                    <File title="Profile Picture" subtitle="Upload a profile picture for the administrator" file={ typeof file === 'string' ? file : undefined } setValue={ setFile } />
                </div>

                <div className="div_btn">
                    <div className="input">
                        <Input_Text title="Name" type="text" value={ name } setValue={ setName } placeholder="Enter your name" required={ true } />
                    </div>
                </div>

                <div className="div_btn">
                    <div className="input">
                        <Input_Text title="Email" type="email" value={ email } setValue={ setEmail } placeholder="Enter your email" required={ true } />
                    </div>
                </div>

                <div className="div_btn div_row">
                    <div className="input">
                        <Input_Password title="Password" value={ password } setValue={ setPassword } placeholder="Enter your new password" required={ pageId === 0 } />
                    </div>

                    <div className="input">
                        <Input_Password title="Confirm Password" value={ password2 } setValue={ setPassword2 } placeholder="Confirm your new password" required={ pageId === 0 } />
                    </div>
                </div>

                <div className="type_password">
                    <div className={ passwordCheck.minLength ? "yes_save" : "not_save" }>The password must be at least 6 characters long.</div>
                    <div className={ passwordCheck.special   ? "yes_save" : "not_save" }>The password must contain special characters.</div>
                    <div className={ passwordCheck.hasNumber ? "yes_save" : "not_save" }>The password must contain at least 1 number.</div>
                    <div className={ passwordCheck.hasUpper  ? "yes_save" : "not_save" }>The password must contain at least 1 uppercase letter.</div>
                    <div className={ passwordCheck.match     ? "yes_save" : "not_save" }>The passwords must match.</div>
                </div>

                <div className="div_btn div_row">
                    <Btn title="Cancel" type="btn_cancel" OpenFuncition={ handleClose } />
                    <Btn title="Save" />
                </div>
            </div>
        </form>
    )
}